enum SignatureRemoveDialogFields {
	FLATTEN = "flatten"
}

export default SignatureRemoveDialogFields;